import { useCallback, useEffect, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
import { Star, Quote, ChevronLeft, ChevronRight } from "lucide-react";
import { REVIEWS } from "@/lib/site";
import { Reveal } from "@/lib/motion";

export const Reviews = () => {
  const [emblaRef, embla] = useEmblaCarousel({ loop: true, align: "start" });
  const [selected, setSelected] = useState(0);

  const scrollPrev = useCallback(() => embla && embla.scrollPrev(), [embla]);
  const scrollNext = useCallback(() => embla && embla.scrollNext(), [embla]);

  useEffect(() => {
    if (!embla) return;
    const onSelect = () => setSelected(embla.selectedScrollSnap());
    embla.on("select", onSelect);
    onSelect();
    const id = setInterval(() => embla.scrollNext(), 4500);
    return () => clearInterval(id);
  }, [embla]);

  return (
    <section id="avaliacoes" className="relative py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <Reveal className="max-w-xl">
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#55c0e0] mb-4">Avaliações</p>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#012a60] text-balance">
              O que nossos clientes dizem
            </h2>
            <div className="mt-4 flex items-center gap-2">
              <div className="flex">
                {[...Array(5)].map((_, i) => <Star key={i} size={18} className="fill-[#f5b301] text-[#f5b301]" />)}
              </div>
              <span className="text-sm font-semibold text-[#012a60]">Empresa 5 estrelas no Google</span>
            </div>
          </Reveal>
          <div className="flex gap-3">
            <button onClick={scrollPrev} data-testid="reviews-prev" aria-label="Anterior"
              className="grid place-items-center h-12 w-12 rounded-full border border-slate-200 text-[#012a60] hover:bg-[#012a60] hover:text-white transition-colors">
              <ChevronLeft />
            </button>
            <button onClick={scrollNext} data-testid="reviews-next" aria-label="Próximo"
              className="grid place-items-center h-12 w-12 rounded-full border border-slate-200 text-[#012a60] hover:bg-[#012a60] hover:text-white transition-colors">
              <ChevronRight />
            </button>
          </div>
        </div>

        <div className="overflow-hidden" ref={emblaRef}>
          <div className="flex gap-6">
            {REVIEWS.map((r, i) => (
              <div key={i} className="min-w-0 shrink-0 grow-0 basis-[85%] sm:basis-[48%] lg:basis-[32%]">
                <div className="h-full rounded-2xl border border-slate-200 bg-slate-50/50 p-7 flex flex-col">
                  <Quote className="text-[#55c0e0] mb-4" size={30} />
                  <div className="flex gap-0.5 mb-3">
                    {[...Array(5)].map((_, j) => <Star key={j} size={15} className="fill-[#f5b301] text-[#f5b301]" />)}
                  </div>
                  <p className="text-slate-700 leading-relaxed flex-1">"{r.text}"</p>
                  <div className="mt-6 flex items-center gap-3">
                    <span className="grid place-items-center h-11 w-11 rounded-full bg-[#012a60] text-white font-bold text-sm">
                      {r.initials}
                    </span>
                    <div>
                      <p className="font-semibold text-[#012a60] text-sm">{r.name}</p>
                      <p className="text-xs text-slate-400">{r.city}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-8 flex justify-center gap-2">
          {REVIEWS.map((_, i) => (
            <button
              key={i}
              onClick={() => embla && embla.scrollTo(i)}
              aria-label={`Ir para avaliação ${i + 1}`}
              className={`h-2 rounded-full transition-all duration-300 ${selected === i ? "w-8 bg-[#012a60]" : "w-2 bg-slate-300"}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
